import validationMixin from '../utils/validationMixin'
import simpleInputWrapper from '../utils/simpleInputWrapper'

export default {
  name: 'FormTextarea',
  mixins: [simpleInputWrapper, validationMixin],

  props: {
    disabled: Boolean,
    rows: String,
    placeholder: String
  }
}
